import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
export const MenuVertical = ({ onClick, icon, label, isRed, size, active, alt, unread, buttonClasses }) => {
    /**
     * twMerge and classNames are used both for better readability of classNames and better merging of twMerge
     * TODO: Remove classNames when twMerge supports objects like syntax
     * @link https://github.com/dcastil/tailwind-merge/discussions/137#discussioncomment-3481605
     */
    const buttonClassName = (isRed) => twMerge(classNames('flex items-center gap-2 border-black rounded-lg truncate text-sm font-semibold w-full group', {
        'px-3 py-2 md:py-3': !size,
        'px-3 py-2 text-sm': size === 'sm',
        'p-3 text-base': size === 'md',
        'p-4 text-lg': size === 'lg',
        'bg-secondary-100': active,
        'text-red': isRed,
        'hover:bg-red-100': alt && isRed,
        'text-gray-700 hover:bg-secondary-100': alt && !isRed,
        'text-gray hover:text-gray-700': !alt && !isRed && !active,
        'bg-red-100': active && isRed,
        'text-gray-700 bg-secondary-100': active && !isRed
    }), buttonClasses);
    const labelClassName = 'flex-1 text-left';
    const unreadClassName = classNames('text-2xs font-semibold rounded-full text-white px-1 h-4 min-w-[16px] flex items-center justify-center', {
        'bg-secondary': active && !isRed,
        'bg-red': active && isRed,
        'bg-gray-400': !active,
        'group-hover:bg-secondary': alt && !isRed,
        'group-hover:bg-red': alt && isRed
    });
    const iconClassName = classNames('flex-none', {
        'text-gray-400': icon === 'patient-filled',
        'text-red-500': icon === 'log-out'
    });
    return (_jsxs("button", { className: buttonClassName(isRed), onClick: onClick, children: [icon && _jsx(Icon, { className: iconClassName, name: icon }), _jsx("span", { className: labelClassName, children: label }), !!unread && _jsx("span", { className: unreadClassName, children: unread })] }));
};
